export const YYYY_MM_DD = 'YYYY/MM/DD'
